import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "hobbies-row flex flex-col lg:flex-row gap-8 lg:gap-20 justify-center items-center lg:items-start" }
const _hoisted_3 = { class: "flex flex-col items-center gap-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col items-center gap-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex flex-col gap-20 items-center" }
const _hoisted_8 = { class: "flex flex-col items-center gap-4" }
const _hoisted_9 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-2 w-full place-items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import EmbroideryImage from '@/assets/Projects/PersonalProjects/CrossStitch.jpg';
import PoetryImage from '@/assets/Projects/PersonalProjects/DewDroppedDeath.png';
import Roses from '@/assets/Projects/PersonalProjects/FlowersPhotos/Roses.jpg';
import Daisies from '@/assets/Projects/PersonalProjects/FlowersPhotos/Daisies.jpg';
import Corsage from '@/assets/Projects/PersonalProjects/FlowersPhotos/Corsage.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'HobbiesInterests',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseCard, {
        title: 'Embroidery',
        "highlight-last-word": true,
        compact: true,
        class: "hobby-card hobby-card-embroidery"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-center space-y" }, [
              _createElementVNode("span", { class: "block" }, "I like to embroider and cross stitch, mainly floral and nature designs"),
              _createElementVNode("span", { class: "block" }, "I create most of my designs myself, here are a few!")
            ], -1)),
            _createElementVNode("img", {
              src: _unref(EmbroideryImage),
              class: "w-full max-w-xs sm:max-w-sm lg:max-w-[50%] cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(EmbroideryImage), 'Embroidery', $event.currentTarget)))
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseCard, {
        title: 'Poetry',
        "highlight-last-word": true,
        compact: true,
        class: "hobby-card hobby-card-poetry"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-center space-y" }, [
              _createElementVNode("span", { class: "block" }, "I write quite a lot of poetry, usually spurred by my love for nature and the simple things."),
              _createElementVNode("span", { class: "block" }, "My favorite poet is Mary Oliver and I take much inspiration from her."),
              _createElementVNode("span", { class: "block" }, "There's so much to life that goes unnoticed, why not try to appreciate it a little?"),
              _createElementVNode("span", { class: "block" }, "Here's a favorite that I've written, which may be published soon!")
            ], -1)),
            _createElementVNode("img", {
              src: _unref(PoetryImage),
              class: "w-full max-w-sm lg:max-w-[70%] cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openImageMenu)(_unref(PoetryImage), 'Poetry', $event.currentTarget)))
            }, null, 8, _hoisted_6)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(BaseCard, {
        title: 'Flowers!',
        "highlight-last-word": false,
        class: "w-auto"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "I have deep love of flowers after spending most of my childhood afternoons in my family's flower shop. From designing arrangements to the Victorian meaning of certain flowers, the language of flowers enthralls me. I try to make a couple arrangements every time I return home from college, both for the flowers and for my family. Here are some of my recent creations: ", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _unref(Roses),
                class: "flex-1 max-h-100 object-cover rounded-lg cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(openImageMenu)(_unref(Roses), 'Roses', $event.currentTarget)))
              }, null, 8, _hoisted_10),
              _createElementVNode("img", {
                src: _unref(Daisies),
                class: "flex-1 max-h-100 object-cover rounded-lg cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(openImageMenu)(_unref(Daisies), 'Daisies', $event.currentTarget)))
              }, null, 8, _hoisted_11),
              _createElementVNode("img", {
                src: _unref(Corsage),
                class: "flex-1 max-h-100 object-cover rounded-lg cursor-pointer",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(openImageMenu)(_unref(Corsage), 'Corsage', $event.currentTarget)))
              }, null, 8, _hoisted_12)
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, [
              _createElementVNode("span", { class: "block" }, "Fun fact about me: daisies will forever be my favorite flower! To me, daisies symbolize growth and positivity in my life that I used to not be able to see, which gives me another reason to wake up every day. Since they commonly grew in my backyard as a child, they often remind me of my inner child, helping me stay in tact with the beauty of life and especially my own life. My dad has taken this to heart as well, giving me a bouqet of daisies every time I leave for Notre Dame to remind me of him."),
              _createElementVNode("span", { class: "block" }, "In Victorian terms, daisies symbolize childhood and innocence, opening the gates for one's inner child to live amidst the stresses of adult life. I try to take this meaning to heart in times of stress, remembering that there will always be a daisy waiting for me on the other side.")
            ], -1))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})